<template>
    <va-create-layout>
        <SellerDealPaymentEvent-form
            :title="title"
            :item="item"
        ></SellerDealPaymentEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
